module.exports = __webpack_public_path__ + "static/media/16@960w.d2f2fe32.jpg";